import FAActiveHomework from './FAActiveHomework';

const ActiveAssessment = () => {
  return <FAActiveHomework />;
};

export default ActiveAssessment;


